import services from 'services/services';
import * as types from '../types';
import { setRequestUrl } from 'store/actions';

// Import helpers
import {
	checkFetchErrors,
	queryParams
} from '../helpers_actions/convert_helpers';

// Import variables
import { TABLE_LENGTH } from 'components/helpers/table';

// ******************** FETCH GEOBLOCK GROUPS - TABLE DATA ********************
export const fetchGeoblockGroups = (options) => async (dispatch, getState) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.FETCH_GEOBLOCK_GROUPS_LOADING,
			payload: true
		});

		const {
			packets: {
				table: {
					columns,
					options: {
						filters: { filterUrlQuery },
						startIndex: startTableIndex,
						page
					}
				}
			}
		} = getState();

		const startIndex =
			options.page === page ? startTableIndex : options.startIndex;

		const url = `/geoblocking/list?${filterUrlQuery}${queryParams(
			options,
			TABLE_LENGTH,
			columns,
			startIndex
		)}`;

		const { data } = await services.get(url);
		// Calculate pages
		const pages = Math.ceil(data.recordsFiltered / TABLE_LENGTH);

		// Dispatch an action with data
		dispatch({
			type: types.FETCH_GEOBLOCK_GROUPS_SUCCESS,
			payload: { ...data, pages, page: options.page, startIndex }
		});

		// save request url in redux
		setRequestUrl(url)(dispatch);
	} catch (error) {
		dispatch({
			type: types.FETCH_GEOBLOCK_GROUPS_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};

// ******************** DELETE GEOBLOCK_GROUPS_ITEM ********************
export const deleteGeoblockGroup = (id) => async (dispatch) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.DELETE_GEOBLOCK_GROUPS_ITEM_LOADING,
			payload: true
		});

		await services.delete(`/geoblocking/${id}`);
		// Dispatch an action with data
		dispatch({
			type: types.DELETE_GEOBLOCK_GROUPS_ITEM_SUCCESS,
			payload: true
		});
	} catch (error) {
		// Dispatch an action with error set to true
		dispatch({
			type: types.DELETE_GEOBLOCK_GROUPS_ITEM_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};

// ******************** SET SEARCH QUERY ********************
export const setGeoblockGroupsQuery = (query) => ({
	type: types.SET_GEOBLOCK_GROUPS_SEARCH_QUERY,
	payload: query
});
